export default __webpack_public_path__ + "assets/partly-cloudy-night-hail.ecbd8fad.svg";